import * as api from '@/api/page'
import Page from '@/store/models/page'

export let state = {
  page: new Page,
  pages: {
    data: []
  },
  pagesList: []
}

export let mutations = {
  setPages: (state, payload) => state.pages = payload,
  setPagesList: (state, payload) => state.pagesList = payload,

  reset: state => state.page = new Page,
  setPage: (state, payload) => state.page = (new Page).hydrate(payload),
  setTitle: (state, payload) => state.page.title = payload,
  setSlug: (state, payload) => state.page.slug = payload,
  setBody: (state, payload) => state.page.body = payload
}

export let actions = {

  paginate: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginate(path, response => {
      commit('setPages', response.data)
      resolve()
    }, reject)
  }),

  all: ({ commit }) => new Promise((resolve, reject) => {
    api.all(response => {
      commit('setPagesList', response.data)
      resolve()
    }, reject)
  }),

  load: ({ commit }, page) => new Promise((resolve, reject) => {
    api.load(page, response => {
      commit('setPage', response.data)
      resolve()
    }, reject)
  }),

  create: ({ state, commit }) => new Promise((resolve, reject) => {
    api.create(state.page, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  save: ({ state, commit }) => new Promise((resolve, reject) => {
    api.save(state.page, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  remove: ({ }, page) => new Promise((resolve, reject) => {
    api.remove(page.id, resolve, reject)
  })

}